import {
    apiRequest,
    employeeWFHDetail,
    employeeWFHUpdate,
    employeeWFHCheckDate
} from "../../../../../services/adapters/kepegawaian/employeeWFHService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", employeeWFHDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", employeeWFHUpdate, {
            body: query
        }, true)
    }

    fetchCheckDate = async (query) => {
        return await apiRequest("post", employeeWFHCheckDate, {
            body: query
        }, true)
    }
}

export default UpdateRepository